// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

// The API returns every entity in one response; the list (37a) renders them
// all, so there is no paging here.
export const getAllData = createAsyncThunk('appEntities/getAllData', async () => {
  const response = await axios.get('/v1/entities')
  return response.data
})

export const entitiesSlice = createSlice({
  name: 'appEntities',
  initialState: {
    allData: [],
    loading: false,
    loaded: false,
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = Array.isArray(action.payload) ? action.payload : []
        state.loading = false
        state.loaded = true
      })
      .addCase(getAllData.rejected, (state, action) => {
        state.loading = false
        state.error = action.error?.message || 'Could not load entities'
      })
  }
})

export default entitiesSlice.reducer
